module.exports = __webpack_public_path__ + "static/img/order.c3a80eb3.png";